
import React from "react";


const Error = (props) => {

    return (
        <div>
            {props.children}
        </div>
    );
};

export default Error;
